import React from 'react'
import { connect } from 'react-redux'
import { closeConfirmationModal } from 'redux/actions/setConfirmationModalState' // eslint-disable-line
import PropTypes from 'prop-types'
import ModalComponent from '../ModalComponent'
import './index.css'

const renderModalBody = (confirmationMessage) => (
  <div
    className="br-confirmation-message"
    dangerouslySetInnerHTML={{ __html: confirmationMessage }} // eslint-disable-line
  />
)

const contactForm = (props) => {
  const {
    confirmationModalVisible,
    header,
    confirmationMessage,
    confirmFunc,
    confirmFuncArgs,
  } = props
  return (
    <ModalComponent
      open={confirmationModalVisible}
      headerTitle={header}
      closeModalEvent={() => {
        props.closeConfirmationModal()
      }}
      closeText="Cancel"
      nextText="Remove"
      nextModalEvent={() => {
        confirmFunc(confirmFuncArgs)
        props.closeConfirmationModal()
      }}
      nextDisabled={false}
      content={renderModalBody(confirmationMessage)}
      modalClass="confirmation-modal"
    />
  )
}

contactForm.propTypes = {
  header: PropTypes.string.isRequired,
  confirmationMessage: PropTypes.string.isRequired,
  confirmationModalVisible: PropTypes.bool.isRequired,
  confirmFunc: PropTypes.func.isRequired,
  confirmFuncArgs: PropTypes.object.isRequired,
  closeConfirmationModal: PropTypes.func.isRequired,
}

const mapStateToProps = ({ confirmationModal }) => confirmationModal

export default connect(mapStateToProps, { closeConfirmationModal })(
  contactForm,
)
